// extracted by mini-css-extract-plugin
module.exports = {"upload-img-button":"UploadImgButton_upload-img-button__19aVt","real-upload-input":"UploadImgButton_real-upload-input__AZYZt"};